import { useParams } from "react-router-dom"
import ContentSingle from "../components/ContentSingle/ContentSingle"

function WatchMore(){
    return(
        <>
        <ContentSingle title="More" form="more"/>
        </>
    )
}

export default WatchMore